import Biblioteca from '@/components/Repositorio/Biblioteca.js'

export default {  
  
  async buscarPropostaOrcamento(axios, api, parametros){   
    parametros.operacao = 'gerarPDFPropostaOrcamento';

    let retorno = {};

    // Gerando o arquivo pdf no servidor.
    await axios.santriGET('/rest/orcamento', parametros, 120, false)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);

      // Se gerou o pdf no servidor buscando e abrindo o arquivo pdf.
      let parametros_pdf = {
        operacao: 'buscarPDFPropostaOrcamento',
        caminho_proposta: retorno.dados.caminho_proposta
      };

      window.open(api + '/rest/orcamento?' + JSON.stringify(parametros_pdf), "_blank");
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    });

    return retorno;
  },
}


// WEBPACK FOOTER //
// ./src/components/Rest/ROrcamento/ROrcamentoBuscarPropostaOrcamento.js